// import * as app from "./route/app";
import {getClient} from "../../config";

export async function getStatesByCountryCode(countryIso: string) {
  return await getClient().get({
    path: "/web/locale/states",
    data: {countryIso},
  });
}
